// slices/meetingSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { apiSlice } from './apiSlice';

// Async Thunks utilisant apiSlice
export const meetingsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Récupérer tous les meetings (pour admin)
    getMeetings: builder.query({
      query: () => '/api/meetings',
      providesTags: ['Meeting'],
    }),
    // Récupérer les meetings d'un formateur spécifique
    getMyMeetings: builder.query({
      query: (userId) => `/api/meetings/my/${userId}`,
      providesTags: ['Meeting'],
    }),
    createMeeting: builder.mutation({
      query: (meetingData) => ({
        url: '/api/meetings',
        method: 'POST',
        body: meetingData,
      }),
      invalidatesTags: ['Meeting'],
    }),
    deleteMeeting: builder.mutation({
      query: (meetingId) => ({
        url: `/api/meetings/${meetingId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Meeting'],
    }),
  }),
});

export const {
  useGetMeetingsQuery,
  useGetMyMeetingsQuery,
  useCreateMeetingMutation,
  useDeleteMeetingMutation,
} = meetingsApiSlice;

// Slice pour la gestion de l'état local
const meetingSlice = createSlice({
  name: 'meetings',
  initialState: {
    meetings: [],
    loading: false,
    error: null,
    currentMeeting: null,
    viewMode: 'all' // 'all' pour admin, 'my' pour formateur
  },
  reducers: {
    setCurrentMeeting: (state, action) => {
      state.currentMeeting = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentMeeting: (state) => {
      state.currentMeeting = null;
    },
    setViewMode: (state, action) => {
      state.viewMode = action.payload;
    }
  },
});

export const { setCurrentMeeting, clearError, clearCurrentMeeting, setViewMode } = meetingSlice.actions;
export default meetingSlice.reducer;